export default {
  setUser: (state: { user: any }, value: any) => (state.user = value),
};
